import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

import { useAuth } from "@/contexts/AuthContext";
import { useImpersonationOptional } from "@/contexts/ImpersonationContext";
import { useLicenseReadonly } from "@/shared/lib/licenseReadonly";
import { ROLES } from "@/shared/lib/rbac";

/**
 * 私有化授权只读横幅(OEM W5-con-private)。全站任何接口撞 LICENSE_READONLY(423)后亮起
 * (信号见 shared/lib/licenseReadonly),直到授权页拉到 mode=OK 才熄。
 * 平台超管(非代客)额外给一个去授权页的链接;租户 / 渠道只看提示(授权页是 /platform/**,他们进不去)。
 */
export function LicenseReadonlyBanner() {
  const { t } = useTranslation("platform-private");
  const readonly = useLicenseReadonly();
  const { user } = useAuth();
  const { isImpersonating } = useImpersonationOptional();
  if (!readonly) return null;
  const isPlatformAdmin = user?.role === ROLES.PLATFORM_ADMIN && !isImpersonating;
  return (
    <div
      role="alert"
      data-testid="license-readonly-banner"
      className="bg-destructive/10 border-b border-destructive/40 text-destructive px-4 py-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm"
    >
      <Lock className="h-4 w-4 shrink-0" />
      <span className="flex-1 font-medium">{t("banner.text")}</span>
      {isPlatformAdmin && (
        <Link to="/platform/license" className="underline underline-offset-2 hover:opacity-80">
          {t("banner.link")}
        </Link>
      )}
    </div>
  );
}
